import { withSentryReactRouterV6Routing } from '@sentry/react';
import { Routes as ReactRouterRoutes } from 'react-router-dom';

const Routes = withSentryReactRouterV6Routing(ReactRouterRoutes);

export default Routes;
